<template>
  <div>
    <v-row no-gutters class="text-h6 font-weight-bold mb-5" v-if="Object.keys(filteredTaskData).length > 0">



      Bonus Tasks

    </v-row>
    <div class="inhouse-task__container">
      <div v-for="(task, index) in filteredTaskData" :key="index">



        <InHouseTaskRectangleTile :name="task.name" :id="String(task.id)"></InHouseTaskRectangleTile>



      </div>
    </div>
    <div v-if="loadingInHouseTasks" class="inhouse-task__container">




      <v-skeleton-loader :elevation="4" type="list-item-avatar-three-line" v-for="n in 10" :key="n"
        color="var(--v-skeleton-loader-color)"></v-skeleton-loader>




    </div>



    <InHouseTaskDialogs></InHouseTaskDialogs>



  </div>
</template>



<script>

import { computed, watch } from "vue";
import { useAuthStore } from "@/store/AuthStore";
import { TILE_DESIGNS } from "@/constants/TileDesigns";
import { UserActivityStore } from '@/store/UserActivityStore';
import { InHouseTaskNames } from "@/constants/InHouseTaskNames";
import InHouseTaskDialogs from "../Dialogs/InHouse-Task-Dialogs.vue";
import InHouseTaskRectangleTile from "@/components/Tiles/Earn/InHouse-Task-Rectangle-Tile.vue";

export default {
  name: 'HouseTaskComponent',
  components: {
    InHouseTaskDialogs,
    InHouseTaskRectangleTile,
  },
  setup() {
    const authStore = useAuthStore();
    const inHouseTaskStore = UserActivityStore();
    const loadingInHouseTasks = computed(() => inHouseTaskStore.loadingInHouseTasks);
    const inHouseTasks = computed(() => inHouseTaskStore.inHouseTasks);


    // Select the referral task if the user has a referral code
    // This is for the scenario where user clicks on the referral link and lands on our website
    watch(() => inHouseTasks.value, (newValue) => {
      if (authStore.referralCode) {
        inHouseTaskStore.selectInHouseTaskByName(InHouseTaskNames.ENTER_REFERRAL);
      }
    })




    return { inHouseTaskStore, TILE_DESIGNS, loadingInHouseTasks };
  },
  computed: {
    filteredTaskData() {
      return Object.values(this.inHouseTaskStore.inHouseTasks).filter(task => task.availability_info.is_available);
    }
  },
}
</script>
